import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useGetDriverWorkHistoryInfo = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [historyInfoData, setHistoryInfoData] = useState<any>(null);

    const onGetDriverWorkHistoryInfoError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            err?.response?.data?.message ?? 'Something went wrong while fetching driver work history info.',
        );
    };

    const onGetDriverWorkHistoryInfoSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        setHistoryInfoData(data);
    };

    const getDriverWorkHistoryInfo = (driverId: string) => {
        const url: HttpConfig = {
            url: `api/v1/dispatchers/${driverId}/statistics`,
            method: 'get',
        };

        request(url, onGetDriverWorkHistoryInfoSuccess, setLoading, onGetDriverWorkHistoryInfoError);
    };

    return { getDriverWorkHistoryInfo, loading, historyInfoData };
};

export default useGetDriverWorkHistoryInfo;
